export type ClaimRewards = {
    banner_title: string;
    number_of_rewards: string;
    icon_name: string;
    icon_category: string;
    cta_link: string;
};

export type AtmosCTAItem = {
    claim_rewards: ClaimRewards;
    uid: string;
};

export enum BankCardDesignatorType {
  BoFA = "95",
  SmallBusiness = "79",
  Default = "00",
}

export const BankCardCodeType = {
  Summit: "ID",
  Barclays: ["CE", "HE", "HC", "HB", "BH"],
  SmallBusiness: "AT",
  Default: "SC",
} as const;

export interface IReward {
  Id: string;
  Name: string;
  Status: string;
  IssueDate: string;
  ExpirationDate: string;
  CreationDate: string;
  [key: string]: string | number | boolean | undefined;
}

export interface IMemberBankInfo {
  creditCardDetails: IBankCard[];
  topRankedBankCardDesignator: string;
  topRankedBankCardDesignatorCode: string;
}

export interface IBankCard {
  openDate: string;
  closedDate: string;
  tsysCode: string;
}